import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function Faq() {
  const {
    t
  } = useLanguage();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 bg-sand-light" data-id="element-39">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-40">
        <div className="text-center mb-16" data-id="element-41">
          <h2 className="text-4xl font-heading font-bold text-ocean-dark mb-4" data-id="element-42">
            {t.faq.title}
          </h2>
          <div className="w-24 h-1 bg-turquoise mx-auto rounded-full" data-id="element-43" />
        </div>

        <div className="space-y-4" data-id="element-44">
          {t.faq.items.map((item, idx) => <div key={idx} className="bg-white rounded-2xl shadow-sm overflow-hidden border border-gray-100" data-id="element-45">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-46">
                <span className="font-semibold text-gray-800 pr-4" data-id="element-47">
                  {item.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-turquoise transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-48" />
              </button>
              <AnimatePresence data-id="element-49">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} className="overflow-hidden" data-id="element-50">
                    <div className="px-6 pb-5 text-gray-600 leading-relaxed" data-id="element-51">
                      {item.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}